import * as React from "react";
import useWindowSize, { WindowSize } from "hook/useWindowSize";
import usePage, { Page } from "usePage";

export type IPageContext = {
  page: Page;
  setPage: (p: Page) => void;
  size: WindowSize;
  hero: boolean;
  setHero: (b: boolean) => void;
};

const defaultContext: IPageContext = {
  page: {
    section: "home"
  },
  size: {
    width: 0,
    height: 0
  },
  setPage: (p) => null,
  hero: true,
  setHero: (b: boolean) => null
};

export const PageContext = React.createContext<IPageContext>(defaultContext);

export default function PageContextProvider({ children }: { children: React.ReactNode }) {
  const size = useWindowSize();
  const [page, setPage] = usePage();
  const [hero, setHero] = React.useState(true);
  const [contextValue, setContextValue] = React.useState<IPageContext>({
    ...defaultContext,
    size,
    setPage: (p: Page) => {
      window.location.hash = p.section;
      setPage(p);
    },
    hero,
    setHero: (b: boolean) => {
      setHero(b);
    }
  });

  React.useEffect(() => {
    setContextValue((c) => ({ ...c, page }));
  }, [page]);

  React.useEffect(() => {
    setContextValue((c) => ({ ...c, size }));
  }, [size]);

  return <PageContext.Provider value={contextValue}>{children}</PageContext.Provider>;
}

export function usePageContext() {
  const context = React.useContext(PageContext);
  if (context === undefined) {
    throw new Error("usePageContext must be used within a PageContextProvider");
  }
  return context;
}
